import * as yup from 'yup'

import constants from 'constants/index'

const { FILE_IMPORT_TYPE, FILE_IMPORT_MIMES_TYPE } = constants.consent

const schema = yup.object().shape({
  fileToImport: yup.mixed().fileUpload({
    types: FILE_IMPORT_TYPE,
    mimeTypes: FILE_IMPORT_MIMES_TYPE,
    required: true,
  }),
})

export default schema
